export const buildCreatedVenueSelection = (ownership, rooms, venueOwnerships) => {
  const newRooms = ownership.rooms || [];
  const newOwnership = {
    ...ownership,
    room_ids: newRooms.map((r) => r.id),
  };
  const firstRoom = newRooms[0];
  return {
    rooms: [...(rooms || []), ...newRooms],
    venueOwnerships: [...(venueOwnerships || []), newOwnership],
    selectedRooms: firstRoom
      ? [{ value: firstRoom.id, label: firstRoom.name, room: firstRoom, venueOwnershipId: newOwnership.id }]
      : [],
    selectedVenue: { value: ownership.venueable_id, label: ownership.name, id: ownership.venueable_id },
  };
};
